/* Mundo Mágico privacy integration. Legacy asset name retained for compatibility.
   Custom Google, Meta and TikTok tags load only after affirmative marketing consent. */
(function () {
  'use strict';
  var started = false;
  var attempts = 0;

  function consentState() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.currentVisitorConsent !== 'function') return { marketing: false, analytics: false };
    var choice = api.currentVisitorConsent();
    return {
      marketing: choice.marketing === 'yes' && api.marketingAllowed() && (typeof api.saleOfDataAllowed !== 'function' || api.saleOfDataAllowed()),
      analytics: choice.analytics === 'yes' && api.analyticsProcessingAllowed()
    };
  }

  function loadMarketing(state) {
    if (started) return;
    started = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', {
      ad_storage: 'granted', ad_user_data: 'granted', ad_personalization: 'granted',
      analytics_storage: state.analytics ? 'granted' : 'denied'
    });
    var google = document.createElement('script');
    google.async = true;
    google.src = 'https://www.googletagmanager.com/gtag/js?id=AW-18224404202';
    document.head.appendChild(google);
    window.gtag('js', new Date());
    window.gtag('config', 'AW-18224404202');

    !function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');

fbq('init', '1788442339074400');
fbq('track', 'PageView');

    !function (w, d, t) {
  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};


  ttq.load('DB8H13BC77U3SVPIKEJG');
  ttq.page();
}(window, document, 'ttq');
  }

  function syncConsent() {
    var state = consentState();
    if (state.marketing) loadMarketing(state);
    if (!started) return;
    var permission = state.marketing ? 'granted' : 'denied';
    if (typeof window.gtag === 'function') window.gtag('consent', 'update', {
      ad_storage: permission, ad_user_data: permission, ad_personalization: permission,
      analytics_storage: state.analytics ? 'granted' : 'denied'
    });
    if (typeof window.fbq === 'function') window.fbq('consent', state.marketing ? 'grant' : 'revoke');
    if (window.ttq) {
      var method = state.marketing ? 'grantConsent' : 'revokeConsent';
      if (typeof window.ttq[method] === 'function') window.ttq[method]();
    }
  }

  function initializePrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) return syncConsent();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) syncConsent();
      });
    } else if (attempts++ < 40) {
      window.setTimeout(initializePrivacy, 100);
    }
  }

  function preferenceError() {
    window.alert('Não foi possível abrir as preferências agora. Atualize a página e tente novamente ou entre em contato pelo e-mail da Política de cookies.');
  }

  function openPreferences() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      Promise.resolve(window.privacyBanner.showPreferences()).catch(preferenceError);
      return;
    }
    var script = document.querySelector('script[data-mm-privacy-banner]');
    if (script) return;
    script = document.createElement('script');
    script.dataset.mmPrivacyBanner = 'true';
    script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
    script.addEventListener('load', function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        Promise.resolve(window.privacyBanner.showPreferences()).catch(preferenceError);
      } else { script.remove(); preferenceError(); }
    }, { once: true });
    script.addEventListener('error', function () { script.remove(); preferenceError(); }, { once: true });
    document.head.appendChild(script);
  }

  document.addEventListener('visitorConsentCollected', syncConsent);
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('[data-mm-cookie-preferences]');
    if (!button) return;
    event.preventDefault();
    openPreferences();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializePrivacy, { once: true });
  else initializePrivacy();
}());
